export default {
  title: {
    en: 'Would you like to add a monthly fragrance subscription?',
  },
  text: {
    en: `
      A month-to-month subscription to Scentbird. Billed monthly,
      renews automatically, and ships from our warehouse mid-month.
    `,
  },
  emptyProduct: {
    en: `
      Your choice of one 8ml fragrance a month, with a free case included
    `,
  },
  no: {
    en: 'No thanks',
  },
  yes: {
    en: 'Yes, add it!',
  },
}
